import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  WarningArrayItemDeletionComponent,
} from '../../../../warning-array-item-deletion/warning-array-item-deletion.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  RolloverSharesClassOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-shares-class.options';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  RolloverSharesClassShareholderDistributionOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-shares-class-shareholder-distribution.options';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import {AdvancedFormArray} from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-rollover-share-class-share-holder-distributions-form',
  templateUrl: './rollover-share-class-share-holder-distributions-form.component.html',
  styleUrls: ['./rollover-share-class-share-holder-distributions-form.component.scss'],
  standalone: false,
})
export class RolloverShareClassShareHolderDistributionsFormComponent implements OnInit, OnDestroy {

  @Input()
  shareClassForm: AdvancedFormGroup<RolloverSharesClassOptions>;

  @Input()
  shareClassIndex: number;

  @Input()
  form: AdvancedForm<RolloverOptions>;

  shareHoldersSubscription: Subscription;

  shareHoldersKeyValues: { key: string, value: string }[] = [];

  constructor(public modalService: NgbModal, private readonly translateService: TranslateService) {
  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get shareClassShareholderDistribution(): AdvancedFormArray<RolloverSharesClassShareholderDistributionOptions> {
    return this.shareClassForm.formElements.shareholdersDistribution as AdvancedFormArray<RolloverSharesClassShareholderDistributionOptions>;
  }

  ngOnInit() {
    this.mapShareholders(this.form.formElements.shareholders.value);

    this.shareHoldersSubscription = this.form.formElements.shareholders.value$.subscribe(value => {
      this.mapShareholders(value.value);
    });
  }

  ngOnDestroy() {
    this.shareHoldersSubscription.unsubscribe();
  }

  mapShareholders(shareholders) {
    this.shareHoldersKeyValues = shareholders.map((shareHolder) => {
      return {
        key: shareHolder.title,
        value: shareHolder.id,
      };
    });
  }

  getAdjustedCostBase(shareClassShareholderDistribution: AdvancedFormGroup<RolloverSharesClassShareholderDistributionOptions>): AdvancedFormControl<number, number, number> {
    return shareClassShareholderDistribution.formElements.adjustedCostBase as AdvancedFormControl<number, number, number>;
  }

  getFairMarketValue(shareClassShareholderDistribution: AdvancedFormGroup<RolloverSharesClassShareholderDistributionOptions>): AdvancedFormControl<number, number, number> {
    return shareClassShareholderDistribution.formElements.fairMarketValue as AdvancedFormControl<number, number, number>;
  }

  getPaidUpCapital(shareClassShareholderDistribution: AdvancedFormGroup<RolloverSharesClassShareholderDistributionOptions>): AdvancedFormControl<number, number, number> {
    return shareClassShareholderDistribution.formElements.paidUpCapital as AdvancedFormControl<number, number, number>;
  }

  getShareholderId(shareClassShareholderDistribution: AdvancedFormGroup<RolloverSharesClassShareholderDistributionOptions>): AdvancedFormControl<string, string, string> {
    return shareClassShareholderDistribution.formElements.shareholderId as AdvancedFormControl<string, string, string>;

  }

  getShareholdersSelectKeyValues(): { key: string, value: string }[] {
    return this.shareHoldersKeyValues;
  }

  getNumberOfSharesOwned(shareClassShareholderDistribution: AdvancedFormGroup<RolloverSharesClassShareholderDistributionOptions>): AdvancedFormControl<number, number, number> {
    return shareClassShareholderDistribution.formElements.numberOfSharesOwned as AdvancedFormControl<number, number, number>;
  }

  addShareClassShareholderDistribution() {
    this.shareClassShareholderDistribution.appendNew();
  }

  async removeShareClassShareholderDistribution(shareClass: AdvancedFormGroup<RolloverSharesClassOptions>, shareClassShareholderDistributionIndexToRemove: number) {
    const modal = this.modalService.open(WarningArrayItemDeletionComponent);
    (modal.componentInstance as WarningArrayItemDeletionComponent).objectDefinition = 'cette distribution';
    modal.closed.subscribe(async result => {
      if (result === true) {
        (shareClass.formElements.shareholdersDistribution as AdvancedFormArray<RolloverSharesClassShareholderDistributionOptions>).delete(shareClassShareholderDistributionIndexToRemove);

        return;
      }
    });

    return;
  }

}
